import { fromJS } from 'immutable'
import * as types from './action-types'

const InitialState = fromJS({
  fetching: false,
  hero: null
})

export default (state = InitialState, action) => {
    switch (action.type) {
        case types.REQUEST_HERO:
          return state.set('fetching', true)

        case types.RECEIVE_HERO:
          return state
            .set('fetching', false)
            .set('hero', fromJS(action.payload.data.message))

        case types.ERROR_HERO:
          return state 
            .set('fetching', false)
        
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/hero/reducer.js